import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
export default function AdultsBeyondDNA(){
    const beyondDNAWrapper = useRef();
    const leftContentRef = useRef();
    const rightContentRef = useRef();
    const whiteDNARef = useRef();
    const purpleDNARef = useRef();
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
    
        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: beyondDNAWrapper.current,
            start: "top 60%",
            // markers: true,
          }
        })

        // tl2.
        tl1.fromTo(leftContentRef.current, { x: '-100%', opacity: 0, duration: 2 }, { x: 0, opacity: 1 }, '<0')
        tl1.fromTo(rightContentRef.current, { x: '100%', opacity: 0, duration: 2 }, { x: 0, opacity: 1 }, '<0')
        tl1.fromTo(whiteDNARef.current, { x: '-100%', opacity: 0, duration: 2 }, { x: 0, opacity: 1 }, '<1')
        tl1.fromTo(purpleDNARef.current, { scale: 0.5, opacity: 0, duration: 3 }, { scale:1, opacity: 1 }, '<1')
      })
    return(
        <section className="beyond_DNA_section" ref={beyondDNAWrapper}>
            <div className="beyond_DNA_container">
                <div className="beyond_DNA__heading" ref={leftContentRef}>
                    <h3>Going beyond<br  className="beyond_DNA__heading__br_lg"/> your <a href="https://www.genome.gov/genetics-glossary/Deoxyribonucleic-Acid" target="_blank">DNA</a>.</h3>
                </div>
                <div className="beyond_DNA__image_container">
                    <div className="beyond_DNA__image_container__gradient"></div>
                    <StaticImage  placeholder="blurred" loading="eager"  quality={100} className="beyond_DNA__image_container__DNA_strand" ref={whiteDNARef} src="../../images/pages/adults/white_dna.png"></StaticImage>
                    <StaticImage  placeholder="blurred" loading="eager"  quality={100} className="beyond_DNA__image_container__purple_DNA" ref={purpleDNARef} src="../../images/pages/adults/purple_dna.png"></StaticImage>
                </div>
                <div className="beyond_DNA__description" ref={rightContentRef}>
                    <p className="beyond_DNA__description__text">We assess your health history, current symptoms and gut microbiome composition to map foods for a healthy gut, best suited to your profile.</p>
                    <div className="beyond_DNA__description__btn"  onClick={() => navigate(`/sciences`)} style={{'cursor': 'pointer'}}>
                        <p className="beyond_DNA__description__btn__text">Learn more</p>
                        <div className="beyond_DNA__description__btn__icon">
                            <StaticImage  placeholder="blurred" loading="eager"  quality={100}  src="../../images/pages/adults/right-long-arrow.svg" ></StaticImage>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}